<ng-container *ngIf="selectedAnlaufFonds$ | async as fonds">
  <form class="lv-artefact-container lv-component">
    <div class="lv-artefact Width100Prozent">
      <div>
        <div class="lv-label-tooltip-label">
          <div class="lv-anlaufmanagement-header">
            <div class="lv-anlaufmanagement-padding-left">
              Fonds
            </div>
            <div>
              <button mat-button color="primary" onclick="this.blur()" (click)="openAnlaufFonds()">
                <mat-icon color="accent" [svgIcon]="'PenToSquare'"></mat-icon>
                <span class="lv-anlaufmanagement-text-margin-left">Fonds ändern</span>
              </button>
            </div>
          </div>
        </div>
        <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                          [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
        <ng-container *ngIf="!!dataSource && !!dataSource.data.length">
          <lv-anlauf-ablauf-management-table [dataSource]="dataSource"></lv-anlauf-ablauf-management-table>
        </ng-container>
      </div>
    </div>
  </form>
</ng-container>

